var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "index-form-item",
    {
      attrs: {
        labelText: _vm.labelName,
        labelWidth: _vm.labelWidth,
        labelPosition: _vm.labelPosition,
        textAlign: _vm.labelTextPosition,
        formType: _vm.formType,
        paddingLeft: _vm.paddingLeft
      }
    },
    [
      _c(
        "div",
        { staticClass: "form-item_input" },
        [
          _c("el-input", {
            style: { width: _vm.width },
            attrs: {
              type: "text",
              placeholder: _vm.placeholder,
              clearable: _vm.isClearable,
              disabled: _vm.isDisabled,
              "limit-length": _vm.textLength
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c810831c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c810831c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form_item/FormItemInput.vue
// module id = null
// module chunks = 